import { gql } from 'graphql-request';

export const TEACHER_STUDENT_EXERCISE = gql`
  query v2TeacherStudentExercise($studentId: UUID!, $exerciseVersionId: Int!) {
    v2TeacherStudentExercise(
      studentId: $studentId
      exerciseVersionId: $exerciseVersionId
    ) {
      exerciseVersionId
      exerciseId
      exerciseTitle
      exerciseVersionName
      content
      testPlanId
      userId
    }
  }
`;

export const TEACHER_STUDENT_EXERCISE_VERSION_TITLE = gql`
  query v2TeacherStudentExercise($studentId: UUID!, $exerciseVersionId: Int!) {
    v2TeacherStudentExercise(
      studentId: $studentId
      exerciseVersionId: $exerciseVersionId
    ) {
      exerciseVersionName
    }
  }
`;
